import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fontawesome',
  templateUrl: './fontawesome.component.html',
  styleUrls: ['./fontawesome.component.scss']
})

/**
 * Fonr-awesome component - handling the font-awesome icon with navbar and content
 */
export class FontawesomeComponent implements OnInit {
  // bread crumb items
  breadCrumbItems: Array<any>;

  constructor() { }

  ngOnInit() {
    // tslint:disable-next-line: max-line-length
    this.breadCrumbItems = [{ label: 'Aivis', path: '/' }, { label: 'Icons', path: '/' }, { label: 'Font Awesome', path: '/', active: true }];

  }

}
